import { render, staticRenderFns } from "./check.vue?vue&type=template&id=3745b42c&scoped=true&"
var script = {}
import style0 from "./check.vue?vue&type=style&index=0&id=3745b42c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745b42c",
  null
  
)

export default component.exports